import { render, staticRenderFns } from "./EmergencyScenarioDrill.vue?vue&type=template&id=b08a27ae&"
import script from "./EmergencyScenarioDrill.vue?vue&type=script&lang=js&"
export * from "./EmergencyScenarioDrill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports